import React, { Suspense } from 'react';
import { Outlet, useParams } from 'react-router';
import { BasicPage, Flexbox, H1, Menu, MenuItem, Skeleton } from '@sonika-se/ui-kit/components';
import { graphql, useLazyLoadQuery } from 'react-relay/hooks';
import UserNameLabel from '~/components/UserNameLabel';
export const UserLayout = () => {
    const { userId } = useParams();
    const { user } = useLazyLoadQuery(graphql `
      query UserLayoutQuery($userId: ID!) {
        user(id: $userId) {
          ...UserNameLabel_user
        }
      }
    `, {
        userId,
    });
    return (<BasicPage width="large">
      <Flexbox direction="row" gap="medium" style={{ paddingTop: '3rem' }}>
        <H1>
          <UserNameLabel user={user}/>
        </H1>
      </Flexbox>
      <Flexbox direction="column" gap="xlarge">
        <Menu>
          <MenuItem index path="" text="Överblick"/>
        </Menu>
        <Suspense fallback={<Skeleton height="40vh" type="table"/>}>
          <Outlet />
        </Suspense>
      </Flexbox>
    </BasicPage>);
};
export default UserLayout;
